import PanelContent from '@shared/components/PanelContent';
import PanelSkeleton from '@shared/components/PanelSkeleton';
import RetryableError from '@shared/components/RetryableError';
import { ApiRequestError } from '@api/client/apiClient';
import { useHealth } from './hooks/useHealth';
import VesselInfo from './components/VesselInfo';
import VersionInfo from './components/VersionInfo';
import SystemResources from './components/SystemResources';
import LicenseStatus from './components/LicenseStatus';
import OmsConnectivity from './components/OmsConnectivity';

export default function StatusPage() {
  const { data, isLoading, error, refetch } = useHealth();

  if (isLoading) return <PanelSkeleton />;

  if (error || !data) {
    const correlationId =
      error instanceof ApiRequestError ? error.apiError.correlationId : undefined;
    return (
      <RetryableError
        message={error?.message ?? 'Failed to load health status'}
        correlationId={correlationId}
        onRetry={() => void refetch()}
      />
    );
  }

  return (
    <PanelContent>
      <div data-testid="page-status" className="flex flex-col gap-3">
        {data.vessel && <VesselInfo vessel={data.vessel} />}
        <VersionInfo versions={data.versions} />
        <SystemResources resources={data.resources} />
        <LicenseStatus licenses={data.licenses} />
        <OmsConnectivity connected={data.omsConnected} />
      </div>
    </PanelContent>
  );
}
